import { RuleDataQuality } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { t } from 'util/stdtypes';

import { BaseTag } from './base-tag';

export function ManualModerationTag() {
    const { colors } = useTheme();
    return (
        <BaseTag
            backgroundColor={colors.colorSurfacePrimary}
            border='solid'
            color={colors.colorTextPrimary}
            iconFill={colors.colorTextPrimary}
            label={t('moderationtag.manually_moderated', 'Manually moderated')}
            prefix={RuleDataQuality}
            type='big'
        />
    );
}
